
// import '../../App.css'
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const TruckTrendChart = ({ data }) => {
  const months = data.map(item => item.month.substring(0, 3));

  const RequiredColor = getComputedStyle(document.documentElement).getPropertyValue('--cd8').trim();
  const AssignedColor = getComputedStyle(document.documentElement).getPropertyValue('--cd9').trim();
  const ToolTipBG = getComputedStyle(document.documentElement).getPropertyValue('--tooltip-bg').trim();

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      duration: 1500,
      easing: 'easeOutQuart'
    },
    interaction: {
      intersect: false,
      mode: 'index',
    },
    plugins: {
      datalabels: { display: false },
      title: {
        display: false,
        text: 'Truck Trend',
        color: 'rgb(92, 49, 6)'
      },
      legend: {
        position: 'top',
        align: 'start',
        display: false,
        labels: {
          boxWidth: 12,
          padding: 20,
          font: {
            size: 10
          },
          usePointStyle: true,
          generateLabels: (chart) => {
            // Disable click events by making all labels unclickable
            return chart.data.datasets.map((dataset, i) => ({
              text: dataset.label,
              fillStyle: dataset.backgroundColor,
              strokeStyle: dataset.borderColor,
              lineWidth: 1,
              pointStyle: 'rect',
              hidden: false,
              // Disable click events
              datasetIndex: i
            }));
          }
        },
        // Disable click events
        onClick: null,
        onHover: null,
        onLeave: null
      },
      tooltip: {
        backgroundColor: ToolTipBG,
        padding: 12,
        titleFont: {
          size: 14
        },
        bodyFont: {
          size: 13
        },
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.parsed.y} Trucks`
        }
      }
    },
    scales: {
      x: {
        grid: {
          display: false,
          color: 'rgba(0, 0, 0, 0.1)'
        }
      },
      y: {
        beginAtZero: true,
        grid: {
          display: false,
          color: 'rgba(0, 0, 0, 0.1)'
        }
      }
    }
  };

  const chartData = {
    labels: months,
    datasets: [
      {
        label: 'Required',
        data: data.map(item => item.required_trucks),
        backgroundColor: RequiredColor,
        borderColor: RequiredColor,
        borderWidth: 1,
        borderRadius: 5
      },
      {
        label: 'Assigned',
        data: data.map(item => item.assigned_trucks),
        backgroundColor: AssignedColor,
        borderColor: AssignedColor,
        borderWidth: 1,
        borderRadius: 5
      },
    ]
  };

  return (
    <div className="chart-container">
      <Bar data={chartData} options={options} />
    </div>
  );
};

